import { render, staticRenderFns } from "./rText.vue?vue&type=template&id=4352a1bc&"
import script from "./rText.vue?vue&type=script&lang=js&"
export * from "./rText.vue?vue&type=script&lang=js&"
import style0 from "./rText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports